<template>
	<div class="page" :style="{height:fixedHeight+'px'}" style="position: relative;overflow-y: auto;">
		<!-- 头部 -->
		<div class="titleView">
			<el-row>
				<el-col :span="2" :offset="22">
					<el-button type="warning" @click="back" size="small">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="shopClass" >
			<el-table ref="multipleTable1" :data="tableData" tooltip-effect="dark" size="small">
				<el-table-column label="编号" >
					<template slot-scope="scope">
						{{scope.row.code}}
					</template>
				</el-table-column>
				<el-table-column label="名称" >
					<template slot-scope="scope">
						{{scope.row.name}}
					</template>
				</el-table-column>
				<el-table-column label="规格" >
					<template slot-scope="scope">
						{{scope.row.skuName}}
					</template>
				</el-table-column>
				<el-table-column prop="goods_count" label="发货数量" align="center">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.num" controls-position="right" :min="0" :max="1000" style="width:100px" size="small"/>
					</template>
				</el-table-column>
				<el-table-column label="发货总价" align="center">
					<template slot-scope="scope">
						<el-input placeholder="请输入总金额" v-model="scope.row.allMoney" maxlength="30" resize="none" size="small"/>
					</template>
				</el-table-column>
				<el-table-column  label="备注" align="center">
					<template slot-scope="scope">
						<el-input type="textarea" placeholder="请输入内容" v-model="scope.row.remark" maxlength="30" resize="none" clearable size="small"/>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" align="center" width="160">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="tableData.splice(scope.$index,1)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 底部按钮 -->
		<div style="height: 72px;"></div>
		<div class="fix_btn">
			<div>
				<span style="padding:0 10px;">发货单备注</span>
				<el-input placeholder="请输入内容" v-model="remark" maxlength="30" style="width:500px;"/>
			</div>
			<div>
				<el-select style="width:150px;margin-right: 30px;" class="select" v-model="targetShopId" placeholder="请选择配送门店" size="small">
					<el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
					</el-option>
				</el-select>
				<el-button type="warning" @click="drawerSelectProduct_state=true" size="small">添加资产</el-button>
				<el-button type="warning" @click="submit" size="small">确认发货</el-button>
			</div>
		</div>
		<!-- 添加商品弹框 -->
		<div v-if="drawerSelectProduct_state">
			<drawerSelectProduct @submit="submit_drawerSelectProduct"></drawerSelectProduct>
		</div>
	</div>
</template>
<script>
	import drawerSelectProduct from "./drawer_selectProduct.vue"
	export default {
		components: {drawerSelectProduct},
		data() {
			return {
				fixedHeight:0,
				
				drawerSelectProduct_state:false,
				tableData:[],
				remark:'',
				
				targetShopId:'',
				shopList:this.$store.state.userInfo.shopInfos,
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
		},
		methods: {
			back(){
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.go(-1)
				})
			},
			//提交
			submit() {
				if(this.tableData.length == 0){
					this.$message({
						message: '请添加资产',
						type: 'error'
					});
					return
				}
				if(this.$public.isNull(this.targetShopId)){
					this.$message({
						message: '请选择配送门店',
						type: 'error'
					});
					return
				}
				let list = []
				for(let i=0;i<this.tableData.length;i++){
					list.push({
						"assetsCode": this.tableData[i].code.toString(),
						"assetsName":  this.tableData[i].name,
						"skuName":  this.tableData[i].skuName,
						"count": Number(this.tableData[i].num),
						"assetsType": this.tableData[i].type,
						"purchasePrice": this.tableData[i].allMoney*1,
						"purchaseRemark": this.tableData[i].remark
					})
				}
				let params = {
					"shopInfo": {
						"shopId": this.targetShopId,
						"shopName": this.$public.getMatchingItem(this.shopList,'shop_id',this.targetShopId).shop_name,
					},
					"purchaseDetailList":list,
					"purchaseRemark": this.remark,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_zichan+'/api/AssetsPurchase/add', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '发货成功',
							type: 'success'
						});
						this.tableData = []
						this.remark = ''
						this.targetShopId = ''
					}
				})
			},
			//
			submit_drawerSelectProduct(obj) {
				if(obj.type==="success"){
					for(let i=0;i<this.tableData.length;i++){
						if (this.tableData[i].id == obj.data.id) {
							this.$message({
								message: '该资产已添加',
								type: 'warning'
							})
							return
						}
					}
					this.$set(obj.data,'num',1)
					this.$set(obj.data,'allMoney','')
					this.$set(obj.data,'remark','')
					this.tableData.push(obj.data)
				}else if(obj.type==='close'){
					this.drawerSelectProduct_state = false
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		height: 100%;

		// 重复头部
		.titleView {
			// width: 98%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}
		.remarks{
			margin-top: 20px;
			display: flex;
			.labelRemark{
				font-size: 14px;
				margin-right: 10px;
			}
		}
		.fix_btn {
			position: absolute;
			bottom: 0;
			z-index: 6;
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;

			button {
				margin-right: 30px;
			}

			button:nth-of-type(5) {
				margin-right: 60px;
			}
		}
	}
</style>
